(function () {
  const toast = document.getElementById('cart-add-toast');
  if (!toast) return;

  let hideTimeout;

  function showToast() {
    toast.removeAttribute('hidden');
    toast.classList.add('show');

    clearTimeout(hideTimeout);
    hideTimeout = setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => toast.setAttribute('hidden', ''), 100);
    }, 500); // toast visible for 1.2 seconds
  }

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      showToast();
    });
  }
})();



